import { Chip, SelectButton, ToggleButton } from 'primereact';
import React, { useState } from 'react';

export function GraficoVentas() {
  const [value, setValue] = useState(2);
  const items = [
    { name: "Diario", value: 1 },
    { name: "Semanal", value: 2 },
    { name: "Mensual", value: 3 },
    { name: "Trimestral", value: 4 },
    { name: "Anual", value: 5 },
  ];
  const [checked, setChecked] = React.useState(true);
  function handleChange(value) {
    setValue(value);
    if (value === 1) {
      v_periodo = "diario";
      buscarData("diario");
    } else if (value === 2) {
      v_periodo = "semanal";
      buscarData("semanal");
    } else if (value === 3) {
      v_periodo = "mensual";
      buscarData("mensual");
    } else if (value === 4) {
      v_periodo = "trimestral";
      buscarData("trimestral");
    } else {
      v_periodo = "anual";
      buscarData("anual");
    }
  }
  function handleChangeNotaCredito(value) {
    if (value === 1) {
      setChecked(true);
      setValue2(1);
    } else {
      setChecked(false);
      setValue2(null);
    }
    v_notaCredito = !checked;
    crearGrafico(dataGraficoVentas);
  }
  const [value2, setValue2] = useState(1);
  const items2 = [{ name: "Aplicar Notas de Credito", value: 1 }];
  return (
    <React.Fragment>
      <SelectButton
        value={value}
        onChange={(e) => handleChange(e.value)}
        optionLabel="name"
        options={items}
        style={{ marginRight: "5px" }}
      />
      <SelectButton
        pt={{
          button: {
            id: 'notaCredito',
            style: { borderRadius: "6px" },
          },
        }}
        value={value2}
        options={items2}
        optionLabel="name"
        onChange={(e) => handleChangeNotaCredito(e.value)}
      />
    </React.Fragment>
  );
}